<template>
  <Navbar />
  <Carousel />
  <!-- 首頁主要內容起點錨點：跳過 Banner/Hero Section 直達主要內容 (搭配 Skip Link 與 Alt+C) -->
  <div id="main-content" tabindex="-1" class="main-content-anchor">
    <a
      id="accesskey-c"
      href="#accesskey-c"
      accesskey="C"
      class="accesskey-brick sr-only-focusable"
      title="主要內容區塊，快捷鍵：Alt+C"
      aria-label="主要內容區塊"
    >:::</a>
  </div>
  <LatestNews id="latest-news" />
  <RxNormSection />
  <TrainingCertSection />
  <TaiwanStandardSection />
  <!-- <TerminologySearchSection /> -->
  <FooterSection />
</template>
<script setup>
import Navbar from "../components/Navbar.vue";
import Carousel from "../components/Carousel.vue";
import LatestNews from "../components/LatestNews.vue";
import RxNormSection from "../components/RxNormSection.vue";
import TrainingCertSection from "../components/TrainingCertSection.vue";
import TaiwanStandardSection from "../components/TaiwanStandardSection.vue";
import TerminologySearchSection from "../components/TerminologySearchSection.vue";
import FooterSection from "../components/FooterSection.vue";
</script>
